const DEFAULT_LOCALE = 'en';

export const formatCurrency = (value: number, currencyUnit: string | null): string => {
  if (!currencyUnit) {
    return value?.toString();
  }

  try {
    return new Intl.NumberFormat(DEFAULT_LOCALE, {
      style: 'currency',
      currency: currencyUnit.toUpperCase(),
    }).format(value);
  } catch (_) {
    return `${value} ${currencyUnit}`;
  }
};

export const getCurrencySymbol = (currencyCode: string | null): string => {
  if (!currencyCode) return '$';

  try {
    const formatted = new Intl.NumberFormat(DEFAULT_LOCALE, {
      style: 'currency',
      currency: currencyCode.toUpperCase(),
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(0);

    return formatted.replace(/[\d,.\s]/g, '');
  } catch {
    return currencyCode;
  }
};
